import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid} from '@mui/x-data-grid';

const ModalHistorialComprasComponent = (props) => {

    const historial = useSelector(store => store.ModuloInventario.historialCompras)
    console.log("HISTORIAL: ", historial)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 850,
        height: 700,
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const [openModalCompras, setOpenModalCompras] = React.useState(true);

    const handleCloseModal = () => {
        setOpenModalCompras(false)
        props.setOpenModalCompras.setOpenModalCompras()
    }

    const columns = [
        { field: 'pedido', headerName: 'Num. Pedido', headerAlign: 'center', flex: 1.5 },
        { field: 'cantidadMezcal', headerName: 'Mezcal', headerAlign: 'center', flex: 1 },
        { field: 'cantidadBebidasMezcal', headerName: 'Bebidas con mezcal', headerAlign: 'center', flex: 2 },
        { field: 'prefijo', headerName: 'Prefijo', headerAlign: 'center', flex: 1 },
        { field: 'folioInicial', headerName: 'Folio Inicial', headerAlign: 'center', flex: 1 },
        { field: 'folioFinal', headerName: 'Folio Final', headerAlign: 'center', flex: 1 },
    ]

    const rows = [];
    historial?.map(anexo => {
        let cantidadMezcal = '0'
        let cantidadBebidasMezcal = '0'
        if(anexo?.prefijo != ''){
            if(anexo?.fc_40_solicituddeadquisiciondehologramas?.cantidadmezcal != "") cantidadMezcal = anexo?.fc_40_solicituddeadquisiciondehologramas?.cantidadmezcal
            if(anexo?.fc_40_solicituddeadquisiciondehologramas?.cantidadbebidasmezcal != "") cantidadBebidasMezcal = anexo?.fc_40_solicituddeadquisiciondehologramas?.cantidadbebidasmezcal

            rows.push({
                id: uuidv4(), pedido: anexo?.idcomprahologramas, cantidadMezcal: cantidadMezcal,
                cantidadBebidasMezcal: cantidadBebidasMezcal, prefijo: anexo?.prefijo, 
                folioInicial: anexo?.folioinicial, folioFinal: anexo?.foliofinal
            })
        }
        else return null
    })


    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModalCompras}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}> 
                            <center ><h3 style={{ color: "#0D717C", fontFamily: "Montserrat", fontWeight: "bold" }}>Historial de compra </h3></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 525, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={8}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#4399A4',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <button className={`btn btn-outline-success`} style={{width: '50%'}} onClick={() => handleCloseModal()}>Aceptar</button>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalHistorialComprasComponent)
